import { render } from "./SwitchVue.vue?vue&type=template&id=9f26ba58&scoped=true"
import script from "./SwitchVue.vue?vue&type=script&lang=js"
export * from "./SwitchVue.vue?vue&type=script&lang=js"

import "./SwitchVue.vue?vue&type=style&index=0&id=9f26ba58&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f26ba58"]])

export default __exports__